import { render, staticRenderFns } from "./DistributionAfterSale.vue?vue&type=template&id=68d7682c&"
import script from "./DistributionAfterSale.vue?vue&type=script&lang=js&"
export * from "./DistributionAfterSale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports